<template>
  <div class="phoneFrom">
    <el-form
            ref="form"
            :model="form"
            :rules="rules"
            class="login-form">
      <el-form-item prop="phone">
        <el-input class="phone-input"
                v-model="form.phone"
                autocomplete='off'
                placeholder='请输入手机号码'
                style="width: 100%"
                size="large" >
                 <!-- <i slot="prefix" class="el-input__icon el-icon-mobile-phone"><span>+86</span></i> -->
                 <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>

                </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input
                v-model="form.code"
                autocomplete='off'
                placeholder='请输入验证码'
                style="width: 100%"
                size="large"
                class="send-captcha-input"
        >
         <i slot="prefix" class="el-input__icon el-icon-c-scale-to-original"></i>
          <div slot="append" class="send-captcha-btn">
            <el-button
                    @click="sendCode(false)"
                    :loading='loadingCode'
                    :disabled='disabled'>
              {{disabled ? `${count}s后重新发送` :'获取验证码'}}
            </el-button>
          </div>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import * as loginApi from '@/util/api';
  import reg from '@/util/pattern'

  export default {
    data() {
      return {
        preFixPhone: '+86',
        form: {
          phone: '',
          code: ''
        },
        rules: {
          phone: [
            { required: true, message: '请输入手机号码' },
            { pattern: reg.mobileVerify, message: '手机号码格式不正确' }
          ],
          code: [
            { required: true, message: '验证码不能为空' },
            { pattern: reg.verifyCode, message: '验证码格式不正确' }
          ]
        },
        count: 120,
        disabled: false,
        loadingCode: false
      };
    },
    methods: {
      sendCode(flag, data) {
        this.$refs.form.validateField('phone', err => {
          if (!err) {
            if (!flag) {
              this.$emit('sendImageCode', true)
              return
            }
            this.loadingCode = true;
            loginApi.getMobileVeryCode({
              mobile: this.form.phone,
              verify: data.verify,
              barCode: data.imageCode,
            })
                .then(response => {
                  if (response.code === 0) {
                    this.disabled = true;
                    this.$message.success('验证码发送成功！');
                    this.setTimeoutGetCode();
                    this.$emit('sendImageCode', false)
                  } else {
                    this.$message.warning(response.msg);
                    this.$emit('sendImageCode', true)
                  }
                })
                .catch( () => {})
                .finally(() => {
                  this.loadingCode = false
                })
          }
        })
      },
      setTimeoutGetCode() {
        let timer = setInterval(() => {
          if (this.count > 0) {
            this.count --
          }else{
            clearInterval(timer)
            timer = null
            this.count = 120
            this.disabled = false
          }
        }, 1000);
      },
    }
  };
</script>

<style scoped lang="less">
  .phoneFrom {
     .phone-input.el-input--prefix input.el-input__inner{
      padding-left:52px!important;
      }
    .send-captcha-input{
    /deep/  .el-input__inner{
             border-right: 0!important;
             border-radius:8px 0 0 8px ;
             border-top-right-radius: 0!important;
             border-bottom-right-radius:0!important;

      }
     
    }
   
    /deep/ .el-input-group__append {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      background-color: #fff;
      font-size: 12px;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      border-radius:0 8px 8px 0;
      border: 1px solid @c-bg-rgb2;
      border-left: 0;
      &:hover {
        color: #040C2C;
        background-color: #F0F1F3;
      }

      .el-button {
        width: 120px;
        font-size: 12px;
      }
    }
  }
</style>
